import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import axios from "../../../../../api/axios";
import "./reports.scss";

const getReportRowId = (row) =>
  row.bepm_id || `${row.businessEntityId || row.businessName}-${row.productName}`;

const Reports = () => {
  const [reportRows, setReportRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReports = async () => {
      const userData = JSON.parse(sessionStorage.getItem("userData"));

      if (!userData?.Group_ID) {
        setReportRows([]);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `businessEntities/getAllSubscribedRestoNProdsViaGroupId/${userData.Group_ID}`,
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: false,
          },
        );
        setReportRows(response.data?.allProdsNRestos || []);
      } catch (error) {
        console.error("Error fetching report products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  const handleOpenReport = useCallback(
    (report) => {
      sessionStorage.setItem("selectedProductReport", JSON.stringify(report));
      navigate(`/config/reports/${encodeURIComponent(getReportRowId(report))}`, {
        state: { reportContext: report },
      });
    },
    [navigate],
  );

  const columns = useMemo(
    () => [
      {
        field: "businessName",
        headerName: "Entity Name",
        width: 280,
        renderCell: (params) => (
          <div className="reports-cell-with-icon">
            <StorefrontOutlinedIcon className="reports-row-icon" />
            <span>{params.row.businessName || "--------"}</span>
          </div>
        ),
      },
      {
        field: "productName",
        headerName: "Product Name",
        width: 280,
        renderCell: (params) => (
          <div className="reports-cell-with-icon">
            <Inventory2OutlinedIcon className="reports-row-icon" />
            <span>{params.row.productName || "--------"}</span>
          </div>
        ),
      },
      {
        field: "businessType",
        headerName: "Business Type",
        width: 180,
        renderCell: (params) => <span>{params.row.businessType || "--------"}</span>,
      },
      {
        field: "action",
        headerName: "Action",
        width: 180,
        sortable: false,
        renderCell: (params) => (
          <button
            type="button"
            className="reports-action-btn"
            onClick={() => handleOpenReport(params.row)}
          >
            Report
          </button>
        ),
      },
    ],
    [handleOpenReport],
  );

  return (
    <div className="list reports-page">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <div className="reports-content">
          <div className="reports-header">
            <div>
              <h1>Reports</h1>
              <p>Product wise reports by entity.</p>
            </div>
          </div>

          <div className="reports-table">
            <DataGrid
              rows={reportRows}
              columns={columns}
              getRowId={getReportRowId}
              pageSize={9}
              rowsPerPageOptions={[9]}
              loading={loading}
              disableSelectionOnClick
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
